import { render, staticRenderFns } from "./ProjectPlannedResources.vue?vue&type=template&id=74031970&"
import script from "./ProjectPlannedResources.vue?vue&type=script&lang=js&"
export * from "./ProjectPlannedResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports